import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { KYMW1313Component } from './kymw1313.component';

const routes: Routes = [
  {
    path: 'KYMW1313', component: KYMW1313Component
  }
];

/**
 * セット企画検索設定クラス
 *
 * 提供時：
 * app/main/main.routing.module.ts
 *
 * @export KYMW1313RoutingModule
 * @class KYMW1313RoutingModule
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class KYMW1313RoutingModule { }
